import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { UserGroup } from 'types/user_group';

import { useAPI } from 'hooks/api/useAPI';

export type UpdateUserGroupParams = {
  id: string;
  name: string;
};

export function useUpdateUserGroup({
  onSettled,
  ...options
}: UseMutationOptions<UserGroup, APIError, UpdateUserGroupParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ id, ...params }) => {
      const { data } = await client.put<UserGroup>(
        `/apps/${applicationID}/user_groups/${id}`,
        params
      );
      return data;
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['user-groups']);
      },
    }
  );
}
